import React from "react";
import { Grid, Typography, Switch, Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { BasicMuiTable } from "../../../shared";

const AlternativeUoMSection = ({
  ingredient,
  onChange,
  handleAddUnits,
  columns,
}) => {
  return (
    <Grid
      container
      gap="24px"
      py="24px"
      borderBottom="1px solid"
      borderColor="divider"
    >
      <Grid item sm={4}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ width: "150px" }}
        >
          Alternative UoM?
        </Typography>
      </Grid>
      <Grid item flex={1}>
        <Switch
          name="has_uom"
          checked={ingredient.data.has_uom}
          sx={{ marginLeft: "-12px" }}
          onChange={(e) =>
            onChange({
              target: {
                value: e.target.checked ? 1 : 0,
                name: "has_uom",
              },
            })
          }
        />
        {ingredient.data.has_uom ? (
          <Box
            sx={{
              p: "0 8px 8px",
              bgcolor: "#F5F8FC",
            }}
          >
            <BasicMuiTable
              data={ingredient?.data?.units}
              columns={columns}
              tableFooter={
                <Button
                  type="button"
                  size="small"
                  variant="text"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    handleAddUnits(ingredient?.data?.units?.length)
                  }
                >
                  Add Unit
                </Button>
              }
            />
          </Box>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default AlternativeUoMSection;
